<template>
  <div>
    <v-container>
      <h1>
        Flood Cancellation
      </h1>

      <v-row>
        <v-col cols="12" md="8" class="text-right">
          <PolicyServicingHeader :account="account" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="8">
          <v-card class="py-8 px-8 mb-8">
            <ValidationObserver tag="span" ref="observer">
              <form @submit.prevent="validate()">

                <DynamicFormControl :control="{
                                      name: 'CancellationReason',
                                      type: 'Dropdown',
                                      value: cancellationReason,
                                      config: {
                                          label:'What is the primary reason for canceling the policy?',
                                          col: 12,
                                          small: true,
                                          options: cancellationReasons,
                                          rules: 'required',
                                          itemText: 'text',
                                          itemValue: 'value',
                                      }
                                    }"
                                    @change="cancellationReason = $event.value" />

                <DynamicFormControl v-if="cancellationReason == 'Moved policy to another insurance company'"
                                    :control="{
                                      name: 'NewFloodProvider',
                                      type: 'Dropdown',
                                      value: newFloodProvider,
                                      config: {
                                          label:'Who is the new provider?',
                                          col: 12,
                                          small: true,
                                          options: newFloodProviders,
                                          rules: 'required',
                                          short: true,
                                          itemText: 'text',
                                          itemValue: 'value',
                                          indented: true
                                      }
                                    }"
                                    @change="newFloodProvider = $event.value" />

                <DynamicFormControl v-if="cancellationReason == 'No longer need the coverage'"
                                    :control="{
                                      name: 'NoLongerNeededReason',
                                      type: 'Dropdown',
                                      value: noLongerNeededReason,
                                      indented: true,
                                      config: {
                                          label:'Why is coverge no longer needed?',
                                          col: 12,
                                          small: true,
                                          options: noLongerNeededReasons,
                                          rules: 'required',
                                          short: true,
                                          itemText: 'text',
                                          itemValue: 'value'
                                      }
                                    }"
                                    @change="noLongerNeededReason = $event.value" />

                <DynamicFormControl v-if="cancellationReason"
                                    key="CancellationDate"
                                    :control="{
                                      name: 'CancellationDate',
                                      type: 'DateInput',
                                      value: cancellationDate,
                                      indented: true,
                                      config: {
                                          label:'Cancellation Date',
                                          col: 12,
                                          rules: 'required|validDate',
                                          small: true,
                                          short: true,
                                          allowedDates: allowedDates
                                      }
                                    }"
                                    @change="cancellationDate = $event.value" />
                <Banner v-if="cancellationDate" key="CancellationDateBanner" type="warning" bannerMessage="If you cannot pick the correct cancellation effective date, please DO NOT proceed with cancelling the policy. Please contact our <span class='intercom_button'>Digital Customer Support</span> team for help selecting the correct cancellation effective date."/>

                <DynamicFormControl :control="{
                                      name: 'MailingAddressChanged',
                                      type: 'RadioButtonGroup',
                                      value: mailingAddressChanged,
                                      name: 'MailingAddressChanged',
                                      config: {
                                          options: [
                                              {value: true, text: 'Yes'},
                                              {value: false, text: 'No'}
                                          ],
                                          label: 'Has the Mailing Address changed?',
                                          small: true,
                                          short: true,
                                          disabled: loading,
                                          mandatory: true,
                                          required: true,
                                          rules: 'required',
                                          description: mailingAddressDescription,
                                          footnoteClasses: 'footnote-bold'
                                      }
                                  }"
                                    @change="mailingAddressChanged = $event.value" />

                <DynamicFormControl v-if="mailingAddressChanged"
                                    :control="{
                                      name: 'MailingAddress',
                                      type: 'Address',
                                      value: mailingAddress,
                                      indented: true,
                                      config: {
                                          label: 'Mailing Address',
                                          col: 12,
                                          rules: 'required',
                                          short: true,
                                          addressType: 'MAILING'
                                      }
                                    }"
                                    @change="mailingAddress = $event.value" />
                <div class="footnote-bold">
                  <span>Please note that we will be mailing a copy of the cancellation document to the insured and (if applicable) any mortgagees listed on the policy.</span>
                </div>
                <div class="fees-section-title">
                  <span>Fees:</span>
                </div>
                <Banner type="info" bannerMessage="Note:  Service Fees are Fully Earned. If any questions, please reach out to <span class='intercom_button'>Digital Customer Support</span> prior to submitting cancellation."/>

                <div v-if="canOverrideFees" class="fees-wrapper">
                  <Checkbox :value="overrideFees" label="Override Fees" @change="overrideFees = $event"/>
                  <div v-if="overrideFees">
                  <Checkbox :value="overrideAmwinsServiceFee" label="Return Amwins Service fee" @change="overrideAmwinsServiceFee = $event"/>
                  </div>
                </div>

                <DynamicFormControl :control="{
                                      name: 'ElectronicSignature',
                                      type: 'Attestation',
                                      value: attestation,
                                      config: {
                                          label:'',
                                          col: 12,
                                          useGlobalAgentAttestation: true,
                                          rules: 'required',
                                      }
                                    }"
                                    @change="attestation = $event.value" />

                <div class="text-right">
                  <v-btn color="white" large :disabled="loading" @click="returnToAccount" class="ml-4">
                    <Loading v-if="loading" :size="24" class="mr-2" />
                    Cancel
                  </v-btn>
                  <v-btn color="secondary" large type="submit" :disabled="loading" class="ml-4">
                    <Loading v-if="loading" :size="24" class="mr-2" />
                    Submit
                  </v-btn>
                </div>
              </form>
            </ValidationObserver>
          </v-card>
        </v-col>
      </v-row>
      <Dialog
        v-model="showRenewalModal"
        title="Cancel Policy and Upcoming Term"
        @close-dialog="showRenewalModal = false"
        width="500"
        :cardTitleStyle="'padding: 24px 24px 0 24px; border-bottom: 1px solid #E1E6EF;'"
        titleFontWeight="600"
        titleFontSize="16px"
>
        <template #card-text>
          <div class="dialog-content">
            Submitting the cancellation request for the expiring policy will also cancel the upcoming term.
          </div>
        </template>

        <template #card-actions>
          <v-spacer />
            <v-btn
              class="dialog-cancel-btn"
              @click="showRenewalModal = false"
              text
    >
                  Cancel
            </v-btn>
            <v-btn
              class="dialog-submit-btn"
              @click="confirmCancellation"
    >
                 Submit Cancellation
            </v-btn>
        </template>
      </Dialog>
    </v-container>
  </div>
</template>

<script>
  import DynamicFormControl from '@/components/form/DynamicFormControl.vue';
  import Banner from '@/components/ui/Banner.vue';
  import PolicyServicingHeader from '@/components/views/Account/PolicyServicingHeader.vue';
  import { AccountService } from '@/api/AccountService';
  import { PolicyService } from '@/api/PolicyService';
  import Checkbox from '@/components/form/Checkbox.vue';
  import dateformat from 'dateformat';
  import { formatDateForDisplay, isFloodMarket } from '@/scripts/helper';
  import { getUtcDate } from '@/scripts/date-helper';
  import Dialog from '@/components/shared/Dialog.vue';

  export default {
    name: 'FloodCancellation',
    components: {
      DynamicFormControl,
      PolicyServicingHeader,
      Checkbox,
      Banner,
      Dialog
    },
    data () {
      return {
        account: null,
        accountId: '',
        policyId: '',
        termBeginDate: null,
        policy: null,
        loading: false,
        cancellationReason: '',
        newFloodProvider: '',
        noLongerNeededReason: '',
        cancellationDate: '',
        mailingAddress: null,
        mailingAddressChanged: null,
        attestation: null,
        overrideFees: false,
        overrideAmwinsServiceFee: false,
        showRenewalModal: false,
        cancellationReasons: [
          {
            'value': 'Sold the insured property',
            'text': 'Sold the insured property'
          },
          {
            'value': 'Moved policy to another insurance company',
            'text': 'Moved policy to another insurance company'
          },
          {
            'value': 'No longer need the coverage',
            'text': 'No longer need the coverage'
          },
          {
            'value': 'Mortgage paid off',
            'text': 'Mortgage paid off'
          },
          {
            'value': 'Property closing did not occur',
            'text': 'Property closing did not occur'
          },
          {
            'value': 'Cancel to Rewrite',
            'text': 'Cancel to Rewrite'
          }
        ],
        newFloodProviders: [
          {
            'value': 'Private Flood Provider',
            'text': 'Private Flood Provider'
          },
          {
            'value': 'NFIP',
            'text': 'NFIP'
          }
        ],
        noLongerNeededReasons: [
          {
            'value': 'Policy is not acceptable by mortgagee',
            'text': 'Policy is not acceptable by mortgagee'
          }
        ],
        allowedDates: (val) => {
          const today = getUtcDate(new Date());
          today.setHours(0, 0, 0, 0);

          const formattedVal = getUtcDate(val);
          // Users with access to Cancellation_Backdate restricted feature can backdate up to the TermBegin date (regardless of Cancellation reason)
          if (this.canBackdateCancellations && new Date(this.termBeginDate) <= today) {
            return new Date(this.termBeginDate) <= formattedVal && formattedVal < today;
          }
          // If today is earlier than the Term Begin Date, date value must be Term Begin date
          if (new Date(this.termBeginDate) >= today) {
            return new Date(val).toUTCString() === new Date(this.termBeginDate).toUTCString();
          }

          // Cancellation date can be up to 30 days backdated and cannot be a future date
          if (this.cancellationReason == 'Sold the insured property') {
            return (getUtcDate(this.termBeginDate) <= formattedVal) && (formattedVal < today) && (formattedVal >= this.addDays(today, -31));
          }

          // Cancellation date can be backdated to TermBegin date if it's within 10 days of the current date and cannot be a future date
          if (this.cancellationReason == 'Property closing did not occur') {
            if (new Date(this.termBeginDate) >= this.addDays(today, -11)) {
              // Allow 10 days to back date
              return (new Date(this.termBeginDate) <= new Date(val)) && (new Date(val) < today);
            } else {
              // Date must be today
              return new Date(val) <= this.getDateWithoutTime(today) && new Date(val) >= this.getDateWithoutTime(this.addDays(today, -1));
            }
          }

          // Cancellation date can be backdated to TermBegin date if it's within 30 days of the current date and cannot be a future date
          if (this.noLongerNeededReason == 'Policy is not acceptable by mortgagee') {
            if (new Date(this.termBeginDate) >= this.addDays(today, -31)) {
              // Allow 30 days to back date
              return (new Date(this.termBeginDate) <= new Date(val)) && (new Date(val) < today);
            } else {
              // Date must be today
              return new Date(val) <= this.getDateWithoutTime(today) && new Date(val) >= this.getDateWithoutTime(this.addDays(today, -1));
            }
          }
          if (this.cancellationReason == 'Nonpayment') {
            return new Date(val) >= new Date(this.termBeginDate) && new Date(val) <= this.getDateWithoutTime(today);
          }
          // Cancellation date must be policy effective date
          if (this.noLongerNeededReason == 'Void prior to effective date') {
            return new Date(val).toUTCString() === new Date(this.termBeginDate).toUTCString();
          }

          // Date must be today
          return new Date(val) <= this.getDateWithoutTime(today) && new Date(val) >= this.getDateWithoutTime(this.addDays(today, -1));
        }
      };
    },
    watch: {
      overrideFees (val) {
        if (!val) {
          this.overrideAmwinsServiceFee = false;
          this.overrideInspectionFee = false;
        }
      },
      cancellationReason (val) {
        const today = new Date();
        if (new Date(this.termBeginDate) >= today) {
          this.cancellationDate = dateformat(this.getDateWithoutTime(this.termBeginDate), 'mm/dd/yyyy');
        }

        if (val == 'Nonpayment') {
          // Date must be Term Begin date
          this.cancellationDate = dateformat(this.getDateWithoutTime(this.termBeginDate), 'mm/dd/yyyy');
        }

        if ((val == 'Moved policy to another insurance company' || val == 'Mortgage paid off' || val == 'Cancel to Rewrite') && new Date(this.termBeginDate) < today) {
          // Date must be today
          const dformat = dateformat(this.getDateWithoutTime(today), 'mm/dd/yyyy');
          this.cancellationDate = dformat;
        }

        if (val == 'Property closing did not occur') {
          if (new Date(this.termBeginDate) >= this.addDays(today, -11)) {
            // Set date to Term Begin Date. User may change it.
            this.cancellationDate = dateformat(this.getDateWithoutTime(this.termBeginDate), 'mm/dd/yyyy');
          } else {
            // Date must be today
            const dformat = dateformat(this.getDateWithoutTime(today), 'mm/dd/yyyy');
            this.cancellationDate = dformat;
          }
        }

        this.newFloodProvider = '';
        this.noLongerNeededReason = '';
      },
      noLongerNeededReason (val) {
        const today = new Date();
        if (val == 'Void prior to effective date') {
          // Date must be Term Begin date
          this.cancellationDate = dateformat(this.getDateWithoutTime(this.termBeginDate), 'mm/dd/yyyy');
        }

        if (val == 'Policy is not acceptable by mortgagee') {
          if (new Date(this.termBeginDate) >= this.addDays(today, -31)) {
            // Set date to Term Begin Date. User may change it.
            this.cancellationDate = dateformat(this.getDateWithoutTime(this.termBeginDate), 'mm/dd/yyyy');
          } else {
            // Date must be today
            const dformat = dateformat(this.getDateWithoutTime(today), 'mm/dd/yyyy');
            this.cancellationDate = dformat;
          }
        }
      },
      mailingAddressChanged (newValue) {
      if (!newValue) {
        // Reset mailing address when mailingAddressChanged is false
        this.mailingAddress = null;
      }
    }
    },
    async mounted () {
      this.accountId = this.$route.query.accountId;
      this.policyId = this.$route.query.policyId;
      if (this.accountId) {
        this.loading = true;
        await AccountService.get({ id: this.accountId })
          .then((data) => {
            this.account = data;
            if (this.$store.getters.userHasRole('agent') && isFloodMarket(this.account.SalesChannel)) {
              // per user story 597109, don't allow agents for flood or vave do OG cancellations
              this.$router.push({ path: '/account', query: { id: this.accountId } });
              return;
            }
            this.termBeginDate = new Date(this.formatDateForDisplay(this.account.TermList.find(term => term.id == this.policyId).TermBegin, true));
            const today = this.getDateWithoutTime(new Date());
            if (this.termBeginDate >= today) {
              this.noLongerNeededReasons.push({
                'value': 'Void prior to effective date',
                'text': 'Void prior to effective date'
              });
            }
          }).catch(() => {
            this.$store.dispatch('toastError', { Message: 'Error initializing cancellation' });
          })
          .finally(() => {
            this.loading = false;
          });
      }

      if (this.showNonpaymentItem) {
        this.cancellationReasons.push({
          'value': 'Nonpayment',
          'text': 'Nonpayment'
        });
      }
    },
    computed: {
      mailingAddressDescription () {
        return 'If you require the Cancellation Notice to be sent to an alternate address, please enter a new mailing address.';
      },
      canBackdateCancellations () {
        return this.$store.getters.userHasRestrictedFeature('Cancellation_Backdate');
      },
      showNonpaymentItem () {
        return this.$store.getters.userHasRestrictedFeature('Account_FloodNonpayment');
      },
      canOverrideFees () {
        return this.$store.getters.userHasRestrictedFeature('cancellation_fee_override');
      },
      hasRenewal () {
        const hasRenewalOffer = this.account?.AccountStatus === "RenewalOffered";
        const hasFuturePolicyTerms = this.account?.TermList?.some(term =>
          term.id !== this.policy?.Policy?.id &&
          term.PolicyTermStatus === 'Issued' &&
          new Date(term.TermBegin) > new Date(this.policy?.Policy?.TermBegin)
        );

        return hasRenewalOffer || hasFuturePolicyTerms;
      }
    },
    methods: {
      formatDateForDisplay,
      returnToAccount () {
        this.$router.push({ path: '/account', query: { id: this.account.id } });
      },
      addDays (date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
      },
      getDateWithoutTime (date) {
        var dateString = date.toDateString();
        return new Date(dateString);
      },
      formatDate (date) {
            if (!date) return null;
            const [year, month, day] = date.split('-');
            return `${month}/${day}/${year}`;
      },
      submitCancellation () {
              let cancellationForm = {};
              cancellationForm.AccountId = this.accountId;
              cancellationForm.CancellationReason = this.cancellationReason;
              cancellationForm.NoLongerNeededReason = this.noLongerNeededReason;
              cancellationForm.NewFloodProvider = this.newFloodProvider;
              cancellationForm.MailingAddress = this.mailingAddress;
              cancellationForm.EffectiveDate = this.cancellationDate;
              cancellationForm.Attestation = this.attestation;
              cancellationForm.OverrideFees = this.overrideFees;
              cancellationForm.OverrideAmwinsServiceFee = this.overrideAmwinsServiceFee;
              cancellationForm.PolicyId = this.policyId;
              PolicyService.cancelRequest({ body: cancellationForm })
                .then(() => {
                  this.$router.push({ path: '/account', query: { id: this.account.id } }).then(() => {
                    this.$store.dispatch('toastSuccess', { Message: 'Successfully submitted cancellation request' });
                  });
                })
                .catch(() => {
                  this.$store.dispatch('toastError', { Message: 'Failed to process cancellation request' });
                });
      },
      confirmCancellation () {
        this.showRenewalModal = false;
        this.submitCancellation();
      },
      validate () {
        this.loading = true;
        this.$refs.observer.validate()
          .then(valid => {
            if (valid) {
              if (this.hasRenewal) {
                this.showRenewalModal = true;
              } else {
                this.submitCancellation();
              }
            }

            this.loading = false;
          });
      }
    }
  };
</script>

<style scoped lang="scss">
.footnote-bold {
  font-weight: bold;
  margin-bottom: 0;
  margin-top: 10px;
}
.fees-section-title{
  font-weight: bold;
  margin-top:10px;
  padding-top: 10px;
  border-top: 1px solid #DDDDDD;
}
.fees-wrapper {
  margin-bottom:10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #DDDDDD;
}
:deep(.intercom_button) {
  cursor: pointer;
  text-decoration: underline;
}

.dialog-content {
  padding: 16px 24px 24px;
  font-size: 15px;
  color: #4A4A4A;
  line-height: 1.6;
}

.dialog-cancel-btn {
  border: 1.5px solid #0D2940;
  color: #0D2940;
  background-color: white;
  font-weight: 600;
  font-size: 14px;
  padding: 8px 16px;
  border-radius: 6px;
  text-transform: none;
  min-width: 140px;
  box-shadow: none !important;
}

.dialog-submit-btn {
  background-color: #0D2940 !important;
  color: white !important;
  font-weight: 600;
  font-size: 14px;
  padding: 8px 16px;
  border-radius: 6px;
  text-transform: none;
  min-width: 140px;
  box-shadow: none !important;
}
</style>
